import { render, staticRenderFns } from "./GLAccounts.vue?vue&type=template&id=4a926b04&scoped=true"
import script from "./GLAccounts.vue?vue&type=script&lang=js"
export * from "./GLAccounts.vue?vue&type=script&lang=js"
import style0 from "./GLAccounts.vue?vue&type=style&index=0&id=4a926b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a926b04",
  null
  
)

export default component.exports